import { ApiClient } from 'app/service/api-service'
import { IPayloadCreateTeamActivity, IPayloadUpdateTeamActivity } from './model'
import { TeamActivityPoint } from './constant'
export const requestPostCreateTeamActivity = (
  body: IPayloadCreateTeamActivity,
) =>
  ApiClient.Post({
    url: TeamActivityPoint.CREATE,
    body,
  })

export const requestUpdateTeamActivity = (body: IPayloadUpdateTeamActivity) =>
  ApiClient.Put({
    url: TeamActivityPoint.UPDATE,
    body,
  })

export const requestDeleteTeamActivity = (id: number) =>
  ApiClient.Put({
    url: TeamActivityPoint.DELETE,
    body: { id },
  })
